export const ORDER_TYPE = {
    TAKEOUT: 1,
    DINEIN: 2,
};
